import { ApiConfig } from "../apiConfig/apiConfig";
import { apiPost } from "../apiConfig/apiCall";

const AuthService = {
  /**
   * Step 1: Verify credentials and send OTP
   */
  authStep1: async ({ email, password }) => {
    const { baseAdminAuth, authStep1 } = ApiConfig;
    const url = baseAdminAuth + authStep1;
    return apiPost(url, { email, password });
  },

  /**
   * Step 2: Verify OTP and get JWT
   */
  authStep2: async ({ email, password, otp }) => {
    const { baseAdminAuth, authStep2 } = ApiConfig;
    const url = baseAdminAuth + authStep2;
    return apiPost(url, { email, password, otp });
  },

  /**
   * Resend OTP to admin email
   */
  resendOtp: async (email) => {
    const { baseAdminAuth, authResendOtp } = ApiConfig;
    const url = baseAdminAuth + authResendOtp;
    return apiPost(url, { email });
  },
};

export default AuthService;
